import React from 'react'
import IntlMessages from '@vacationtracker/shared/components/utils/IntlMessages'
import { MemberStatus } from '@vacationtracker/shared/types/team-energy'

interface IStatusPillProps {
  status: MemberStatus
}

export const STATUS_I18N_KEY: Record<MemberStatus, string> = {
  peak: 'teamEnergy.status.peak',
  energized: 'teamEnergy.status.energized',
  functional: 'teamEnergy.status.functional',
  struggling: 'teamEnergy.status.struggling',
  drained: 'teamEnergy.status.drained',
  opted_out: 'teamEnergy.status.optedOut',
}

const StatusPill: React.FC<IStatusPillProps> = ({ status }) => {
  return (
    <span className={`te-status-pill te-status-pill--${status.replace('_', '-')}`}>
      <span className="te-status-pill__dot" />
      <IntlMessages id={STATUS_I18N_KEY[status]} />
    </span>
  )
}

export default StatusPill
